<template>
    <v-dialog v-model="dialog" persistent width="400">
        <v-card>
            <v-toolbar class="text-h5 white--text" color="primary">
                <v-icon class="mr-2" color="white">upload_file</v-icon>
                Caricamento file
            </v-toolbar>
            <v-card-text class="my-5">
                <span hide-details>Selezionare la cartella di destinazione</span>
                <v-select :disabled="loading" class="mt-0" :no-data-text="'Nessun dato disponibile'" item-text="nome"
                    item-value="nome" v-model="directorySel" :items="listaSceltaDirectory" hide-details
                    label="Cartella"></v-select>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="chiudiDialogSceltaDirectory(false)">
                    ANNULLA
                </v-btn>
                <v-btn color="primary" text @click="creaSottoCartella()">
                    CONFERMA
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialog: { type: Boolean, default: false },
        listaSottoDirectory: { type: Array, default: null },
    },

    data: () => ({
        loading: false,
        directorySel: null,
        listaSceltaDirectory: [],
    }),

    methods: {
        chiudiDialogSceltaDirectory(value, directorySel) {
            this.directorySel = null;
            this.listaSceltaDirectory = [];
            this.$emit("chiudiDialogSceltaDirectory", value, directorySel);
        },

        creaSottoCartella() {
            if (this.directorySel == null || this.directorySel == undefined) return;
            this.chiudiDialogSceltaDirectory(true, this.directorySel)
        },
    },

    watch: {
        dialog(newVal) {
            if (newVal) {
                Object.assign(this.listaSceltaDirectory, this.listaSottoDirectory);
                let par = {
                    altezzaPX: "",
                    dataCaricamento: "",
                    dataModifica: "",
                    dimensione: 0,
                    estensione: "",
                    larghezzaPX: "",
                    nome: "",
                    nomeCartella: "",
                    path: "",
                    tipo: "",
                    tipoDimensioneFile: "",
                }
                this.listaSceltaDirectory.unshift(par);
            }
        }
    },
};
</script>